export default {
    show_changes_history_title: "Historial de cambios",
    show_changes_history_version: "Versión",
    show_changes_history_updated_on: "Actualizado en",
    show_changes_history_view_changes: "Ver Cambios",
    show_changes_history_compare: "Comparar",
    show_changes_history_settings: "Configuración Dispositivo",
    show_changes_history_cloud_config: "Configuración de la nube",
    show_changes_history_compare_vesions: "Cambio entre versiones "
}